import styled from 'styled-components';
import Box from './Box';
const Flex = styled(Box).withConfig({
  displayName: "Flex",
  componentId: "arghxi-0"
})([""]);
Flex.defaultProps = {
  display: 'flex'
};
export default Flex;